import { useState } from "react";
import cvData from "../data/cvData";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus("");

    try {
      // const endpoint = "http://localhost:8000/send-message.php";
      const endpoint = "/api/send-message.php";
      const res = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (result.success) {
        setStatus("Mesajınız başarıyla gönderildi!");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatus(
          result.error ||
            "Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.",
        );
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setStatus(
        "Bir ağ hatası oluştu. Lütfen internet bağlantınızı kontrol edin.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-100 via-cream-50 to-navy-50">
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes slideInLeft {
          from { opacity: 0; transform: translateX(-30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes slideInRight {
          from { opacity: 0; transform: translateX(30px); }
          to { opacity: 1; transform: translateX(0); }
        }
        @keyframes scaleIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-fadeInUp { animation: fadeInUp 0.6s ease-out forwards; }
        .animate-slideInLeft { animation: slideInLeft 0.6s ease-out forwards; }
        .animate-slideInRight { animation: slideInRight 0.6s ease-out forwards; }
        .animate-scaleIn { animation: scaleIn 0.5s ease-out forwards; }
        .delay-100 { animation-delay: 0.1s; }
        .delay-200 { animation-delay: 0.2s; }
        .delay-300 { animation-delay: 0.3s; }
        .delay-400 { animation-delay: 0.4s; }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Hero Section */}
        <div className="text-center mb-16 opacity-0 animate-fadeInUp">
          <div className="relative inline-block">
            <div className="absolute -inset-1 bg-gradient-to-r from-navy-600 via-navy-700 to-navy-800 rounded-2xl blur opacity-25"></div>
            <h1 className="relative text-5xl md:text-6xl font-serif font-bold text-navy-900 tracking-tight">
              İletişim
            </h1>
          </div>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-navy-600 to-transparent mx-auto mb-6 mt-4"></div>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Size en iyi hizmeti sunabilmek için buradayız. Her türlü soru, öneri
            ve geri bildiriminiz için iletişim formunu kullanabilirsiniz.
          </p>
        </div>

        {/* Contact Grid */}
        {/* DÜZELTME BURADA: 'items-start' eklendi. Bu sayede form, sol taraf kadar aşağı uzamaz. */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Contact Info (Sol Taraf) */}
          <div className="space-y-8">
            {/* Main Contact Info */}
            <div className="group relative opacity-0 animate-slideInLeft">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-navy-600 to-cream-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition-all duration-300"></div>
              <div className="relative bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-105">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-serif font-bold text-navy-900">
                    İletişim Bilgileri
                  </h2>
                  <div className="w-12 h-1 bg-gradient-to-r from-navy-600 to-cream-600 rounded-full transition-all duration-300 group-hover:w-16"></div>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start gap-4 group/contact transition-all duration-300 hover:translate-x-2">
                    <div className="w-12 h-12 bg-gradient-to-r from-navy-100 to-cream-100 rounded-full flex items-center justify-center group-hover/contact:bg-gradient-to-r group-hover/contact:from-navy-600 group-hover/contact:to-cream-600 transition-all duration-300 group-hover/contact:scale-110 group-hover/contact:rotate-12">
                      <span className="text-2xl">📧</span>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700 mb-1">
                        E-posta
                      </p>
                      <a
                        href={`mailto:${cvData.personal.email}`}
                        className="text-navy-700 hover:text-navy-900 hover:underline transition-colors duration-300 text-lg"
                      >
                        {cvData.personal.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 group/contact transition-all duration-300 hover:translate-x-2">
                    <div className="w-12 h-12 bg-gradient-to-r from-navy-100 to-cream-100 rounded-full flex items-center justify-center group-hover/contact:bg-gradient-to-r group-hover/contact:from-navy-600 group-hover/contact:to-cream-600 transition-all duration-300 group-hover/contact:scale-110 group-hover/contact:rotate-12">
                      <span className="text-2xl">📞</span>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700 mb-1">
                        Telefon
                      </p>
                      <a
                        href={`tel:${cvData.personal.phone.replace(/\s/g, "")}`}
                        className="text-navy-700 hover:text-navy-900 hover:underline transition-colors duration-300 text-lg"
                      >
                        {cvData.personal.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 group/contact transition-all duration-300 hover:translate-x-2">
                    <div className="w-12 h-12 bg-gradient-to-r from-navy-100 to-cream-100 rounded-full flex items-center justify-center group-hover/contact:bg-gradient-to-r group-hover/contact:from-navy-600 group-hover/contact:to-cream-600 transition-all duration-300 group-hover/contact:scale-110 group-hover/contact:rotate-12">
                      <span className="text-2xl">📍</span>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700 mb-1">Adres</p>
                      <p className="text-gray-600 text-lg">
                        {cvData.personal.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 group/contact transition-all duration-300 hover:translate-x-2">
                    <div className="w-12 h-12 bg-gradient-to-r from-navy-100 to-cream-100 rounded-full flex items-center justify-center group-hover/contact:bg-gradient-to-r group-hover/contact:from-navy-600 group-hover/contact:to-cream-600 transition-all duration-300 group-hover/contact:scale-110 group-hover/contact:rotate-12">
                      <span className="text-2xl">🏛️</span>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-700 mb-1">
                        Üniversite
                      </p>
                      <p className="text-gray-600 text-lg">
                        {cvData.personal.university}
                      </p>
                      <p className="text-gray-600 text-lg">
                        {cvData.personal.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Office Hours */}
            <div className="group relative opacity-0 animate-slideInLeft delay-200">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-cream-600 to-navy-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition-all duration-300"></div>
              <div className="relative bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-105">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-serif font-bold text-navy-900">
                    Ofis Saatleri
                  </h2>
                  <div className="w-12 h-1 bg-gradient-to-r from-cream-600 to-navy-600 rounded-full transition-all duration-300 group-hover:w-16"></div>
                </div>
                <div className="space-y-4 text-gray-700">
                  <div className="flex items-center gap-3 transition-all duration-300 hover:translate-x-2">
                    <span className="text-2xl">⏰</span>
                    <div>
                      <p className="font-semibold text-navy-900">
                        Pazartesi - Cuma:
                      </p>
                      <p className="text-lg">09:00 - 17:00</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 transition-all duration-300 hover:translate-x-2">
                    <span className="text-2xl">📅</span>
                    <div>
                      <p className="text-sm text-gray-500">
                        Randevu için lütfen önceden e-posta gönderiniz.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Contact */}
            <div className="group relative opacity-0 animate-slideInLeft delay-400">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-navy-600 to-cream-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition-all duration-300"></div>
              <div className="relative bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-2xl transition-all duration-300 cursor-pointer hover:scale-105">
                <div className="flex items-center justify-between mb-6">
                  <h2 className="text-2xl font-serif font-bold text-navy-900">
                    Hızlı İletişim
                  </h2>
                  <div className="w-12 h-1 bg-gradient-to-r from-navy-600 to-cream-600 rounded-full transition-all duration-300 group-hover:w-16"></div>
                </div>
                <div className="space-y-4">
                  <p className="text-gray-600 leading-relaxed">
                    Acil bir sorunuz mu var? Bana doğrudan ulaşmak için telefon
                    veya e-posta adreslerimi kullanabilirsiniz.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      href={`tel:${cvData.personal.phone.replace(/\s/g, "")}`}
                      className="flex-1 bg-gradient-to-r from-navy-600 to-cream-600 text-gray-600 px-6 py-3 rounded-xl font-semibold text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
                    >
                      📞 Ara
                    </a>
                    <a
                      href={`mailto:${cvData.personal.email}`}
                      className="flex-1 bg-gradient-to-r from-cream-600 to-navy-600 text-gray-600 px-6 py-3 rounded-xl font-semibold text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
                    >
                      📧 E-posta
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form (Sağ Taraf) */}
          <div className="group relative opacity-0 animate-slideInRight">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-navy-600 to-cream-600 rounded-2xl blur opacity-25 group-hover:opacity-50 transition-all duration-300"></div>
            <div className="relative bg-white rounded-2xl border border-gray-200 p-8 hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-2xl font-serif font-bold text-navy-900">
                  Mesaj Gönder
                </h2>
                <div className="w-12 h-1 bg-gradient-to-r from-navy-600 to-cream-600 rounded-full transition-all duration-300 group-hover:w-16"></div>
              </div>

              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="group/contact">
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700 mb-2 group-hover/contact:text-navy-700 transition-colors duration-300"
                    >
                      Ad Soyad
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-4 focus:ring-navy-200 focus:border-navy-600 transition-all duration-300 group-hover/contact:border-navy-400 hover:shadow-md"
                    />
                  </div>

                  <div className="group/contact">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700 mb-2 group-hover/contact:text-navy-700 transition-colors duration-300"
                    >
                      E-posta
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-4 focus:ring-navy-200 focus:border-navy-600 transition-all duration-300 group-hover/contact:border-navy-400 hover:shadow-md"
                    />
                  </div>
                </div>

                <div className="group/contact">
                  <label
                    htmlFor="subject"
                    className="block text-sm font-medium text-gray-700 mb-2 group-hover/contact:text-navy-700 transition-colors duration-300"
                  >
                    Konu
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-4 focus:ring-navy-200 focus:border-navy-600 transition-all duration-300 group-hover/contact:border-navy-400 hover:shadow-md"
                  />
                </div>

                <div className="group/contact">
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700 mb-2 group-hover/contact:text-navy-700 transition-colors duration-300"
                  >
                    Mesaj
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-4 focus:ring-navy-200 focus:border-navy-600 transition-all duration-300 group-hover/contact:border-navy-400 resize-none hover:shadow-md"
                  ></textarea>
                </div>

                <div className="text-center">
                  {status && (
                    <p
                      className={`mb-4 text-center p-3 rounded-xl animate-scaleIn ${
                        status.includes("başarıyla")
                          ? "bg-green-100 text-green-700 border border-green-200"
                          : "bg-red-100 text-red-700 border border-red-200"
                      }`}
                    >
                      {status}
                    </p>
                  )}

                  <button
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    className="w-full md:w-auto bg-gradient-to-r from-navy-600 to-cream-600 text-gray-600 px-8 py-4 rounded-xl font-semibold text-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:scale-100 relative overflow-hidden group/button"
                  >
                    <span className="absolute inset-0 bg-gradient-to-r from-cream-600 to-navy-600 opacity-0 group-hover/button:opacity-100 transition-opacity duration-300"></span>
                    <span className="relative">
                      {isSubmitting ? (
                        <div className="flex items-center justify-center gap-3">
                          <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          <span>Gönderiliyor...</span>
                        </div>
                      ) : (
                        "Mesajı Gönder 📤"
                      )}
                    </span>
                  </button>
                </div>

                {/* Buradaki "Gizlilik politikası" yazısını da sildim, tamamen temiz oldu */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
